module.exports = __webpack_public_path__ + "static/img/mechanism-2.cbda8b4b.png";